var App = App || {};

App.SiteAlerts = (function ($) {
    'use strict';

    function init() {
        var alerts = $(".vc-site-alerts");
        var header = $(".vc-site-header");
        var offcanvasNavigation = $("#offcanvasNavigation");

        $(".vc-site-alerts .alert").each(function () {
            this.addEventListener('closed.bs.alert', function () {
                var AlertId = $(this).data("alertid");
                App.Cookies.setItem(AlertId, "closed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");

                var offset = $(header).outerHeight();

                if (alerts.length) {
                    offset += $(alerts).outerHeight();
                }

                $(offcanvasNavigation).css("top", offset);
            })
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteAlerts.init();
});